<template>
  <div>
    <div class="writing-task border border-info rounded p-2">
      <div
        class="checkWritingTask d-flex justify-content-between align-items-baseline mb-2"
      >
        <b-row>
          <b-col sm="12">
            <div class="d-flex">
              <b-form-checkbox
                class="ml-2"
                v-model="writingTask.checkWritingTask"
              >
                <p class="btn p-0 m-0 text-info">
                  Writing Task
                </p>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <div v-if="writingTask.checkWritingTask">
              <label>Score:</label>
              <b-form-input
                v-model="writingTask.scoreForWritingTask"
                placeholder="Enter Score"
                :class="{
                  'form-group-error':
                    $v.writingTask.scoreForWritingTask.$error,
                }"
              />
              <span
                class="input-error-message"
                v-if="
                  !$v.writingTask.scoreForWritingTask.required &&
                  $v.writingTask.scoreForWritingTask.$dirty
                "
              >
                Score is mandatory!
              </span>
            </div>
          </b-col>

          <b-col sm="6">
            <div v-if="writingTask.checkWritingTask">
              <label>Best of score:</label>
              <b-form-input
                v-model="writingTask.best_of_scores"
                placeholder="Optional"
                type="number"
                min="0"
              />
              <small class="form-text text-muted">
                Number of best scores will be considered
              </small>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-collapse
        v-model="writingTask.checkWritingTask"
        class="mt-2"
      >
        <div class="mb-2">
          <span class="font-weight-bolder">
            Choose Score Type:
          </span>
        </div>

        <table class="table table-bordered table-striped">
          <thead class="thead-dark">
            <tr>
              <th></th>
              <th>Writing Task</th>
              <th v-if="!activity_simple_calculation">
                Percent Weightage
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="writingTaskFromApi.length === 0">
              <td colspan="100" class="text-center text-danger">
                No Data Found!
              </td>
            </tr>

            <tr
              v-for="(task, index) in writingTaskFromApi"
              :key="index"
            >
              <td>
                <b-form-checkbox
                  size="sm"
                  v-model="
                    writingTaskConfigStructure[task.id].checkbox
                  "
                />
              </td>

              <td>{{ task.name }}</td>

              <td
                v-if="!activity_simple_calculation"
                class="text-center"
              >
                <b-form-input
                  v-if="
                    writingTaskConfigStructure[task.id].checkbox
                  "
                  placeholder="Enter Percentage"
                  v-model="
                    writingTaskConfigStructure[task.id].input
                  "
                  @blur="$v.writingTaskConfigStructure.$each.$touch()"
                />

                <div
                  v-if="
                    writingTaskConfigStructure[task.id].checkbox &&
                    $v.writingTaskConfigStructure.$each[task.id]
                      .input.$error
                  "
                  class="text-danger"
                >
                  <span
                    v-if="
                      !$v.writingTaskConfigStructure.$each[task.id]
                        .input.required
                    "
                  >
                    This field is required.
                  </span>
                  <span
                    v-if="
                      !$v.writingTaskConfigStructure.$each[task.id]
                        .input.customValidation
                    "
                  >
                    All values must be equal or sum to 100.
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  props: ["saved_configs", "courseReport", "activity_simple_calculation"],

  data() {
    return {
      writingTask: {
        checkWritingTask: false,
        scoreForWritingTask: 20,
        best_of_scores: "",
      },
      writingTaskFromApi: [],
      writingTaskConfigStructure: {},
    };
  },

  async created() {
    await this.getWritingTasks();

    const saved =
      this.saved_configs.activity_catagory_configs.writing_tasks;

    if (saved?.enable) {
      this.writingTask = {
        checkWritingTask: saved.enable,
        scoreForWritingTask: saved.score,
        best_of_scores: saved.best_of_scores,
      };

      Object.keys(saved.resourses.exam || {}).forEach((key) => {
        if (this.writingTaskConfigStructure[key]) {
          this.writingTaskConfigStructure[key].checkbox = true;
          this.writingTaskConfigStructure[key].input =
            saved.resourses.exam[key].persantage_of_wightage;
        }
      });
    }
  },

  validations: {
    writingTask: {
      scoreForWritingTask: {
        required: requiredIf(function () {
          return this.writingTask.checkWritingTask;
        }),
      },
    },

    writingTaskConfigStructure: {
      $each: {
        input: {
          required() {
            return Object.values(this.writingTaskConfigStructure).some(
              (c) => c.checkbox
            );
          },

          customValidation() {
            if (
              !this.writingTask.checkWritingTask ||
              this.activity_simple_calculation
            )
              return true;

            const values = Object.values(
              this.writingTaskConfigStructure
            )
              .filter((c) => c.checkbox)
              .map((c) => Number(c.input));

            if (!values.length) return true;

            const allSame = values.every(
              (v) => v === values[0]
            );
            const sum100 =
              values.reduce((a, b) => a + b, 0) === 100;

            return allSame || sum100;
          },
        },
      },
    },
  },

  methods: {
    async checkValidation() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },

    async getWritingTasks() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/course/${this.courseReport.course_id}/exams`;

      const response = await this.$axios.get(url);

      response.data.forEach((item) => {
        if (item.activity_type === "writing_task") {
          this.$set(this.writingTaskConfigStructure, item.id, {
            checkbox: false,
            input: "",
          });

          this.writingTaskFromApi.push({
            id: item.id,
            name: item.name,
            maximum_mark: item.maximum_mark,
            date: item.end_at
              ? moment(item.end_at)
              : null,
          });
        }
      });
    },
  },
};
</script>

<style>
.writing-task p {
  font-size: 16px;
  font-weight: 600;
}
</style>
